import { Type } from '@angular/core';
import { Operator, QuestionType } from '@empathy/survey/base';

import { CarouselLogicFormComponent } from '../../components/conditional-logic/conditional-operator-forms/carousel-logic-form/carousel-logic-form.component';
import { ConditionalMultiSelectFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-multi-select-form/conditional-multi-select-form.component';
import { ConditionalNpsScoreFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-nps-score-form/conditional-nps-score-form.component';
import { ConditionalNumberFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-number-form/conditional-number-form.component';
import { ConditionalRangeFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-range-form/conditional-range-form.component';
import { ConditionalSingleChoiceFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-single-choice-form/conditional-single-choice-form.component';
import { ConditionalTextFormComponent } from '../../components/conditional-logic/conditional-operator-forms/conditional-text-form/conditional-text-form.component';

import { QuestionOptionsDropdownComponent } from '../../components/conditional-logic/conditional-operator-forms/question-options-dropdown/question-options-dropdown.component';

export const ConditionOperatorFormSettings: Record<Operator, Type<any>> = {
  EQUAL: ConditionalSingleChoiceFormComponent,
  EQUAL_ANY: ConditionalMultiSelectFormComponent,
  NOT_EQUAL: ConditionalSingleChoiceFormComponent,
  INCLUDES_ANY: ConditionalMultiSelectFormComponent,
  INCLUDES_ALL: ConditionalMultiSelectFormComponent,
  NOT_INCLUDES: ConditionalMultiSelectFormComponent,
  NOT_INCLUDES_ALL: ConditionalMultiSelectFormComponent,
  NOT_EMPTY: undefined,
  CONTAINS: ConditionalTextFormComponent,
  NOT_CONTAINS: ConditionalTextFormComponent,
  GREATER_THAN: ConditionalNumberFormComponent,
  GREATER_THAN_OR_EQUAL: ConditionalNumberFormComponent,
  LESS_THAN: ConditionalNumberFormComponent,
  LESS_THAN_OR_EQUAL: ConditionalNumberFormComponent,
  NPS_SCORE: ConditionalNpsScoreFormComponent,
  ONLY_IF: ConditionalMultiSelectFormComponent,
  POSITION_BETWEEN: ConditionalRangeFormComponent,
  POSITION_NOT_BETWEEN: ConditionalRangeFormComponent,
  POSITION_EQUAL: ConditionalSingleChoiceFormComponent,
  POSITION_NOT_EQUAL: ConditionalSingleChoiceFormComponent,
  POSITION_INCLUDES_ANY: ConditionalMultiSelectFormComponent,
  POSITION_GREATER_THAN: ConditionalSingleChoiceFormComponent,
  POSITION_SMALLER_THAN: ConditionalSingleChoiceFormComponent,
  POSITION_GREATER_THAN_OR_EQUAL: ConditionalSingleChoiceFormComponent,
  POSITION_SMALLER_THAN_OR_EQUAL: ConditionalSingleChoiceFormComponent,
  NOT_SELECTED: undefined,
  SELECTED: undefined
};

export const ConditionalLogicByQuestionTypeSettings: Record<QuestionType, Type<any>> = {
  [QuestionType.SingleChoice]: undefined,
  [QuestionType.MultiChoice]: undefined,
  [QuestionType.Input]: undefined,
  [QuestionType.Carousel]: CarouselLogicFormComponent,
  [QuestionType.CarouselMultiChoice]: CarouselLogicFormComponent,
  [QuestionType.CarouselRating]: CarouselLogicFormComponent,
  [QuestionType.Rating]: undefined,
  [QuestionType.Dropdown]: undefined,
  [QuestionType.Essay]: undefined,
  [QuestionType.Heatmap]: undefined,
  [QuestionType.InfoPage]: undefined,
  [QuestionType.FileUpload]: undefined,
  [QuestionType.Terminate]: undefined,
  [QuestionType.HiddenChoice]: undefined,
  [QuestionType.AIChat]: undefined,
  [QuestionType.NPS]: undefined,
  [QuestionType.Ranking]: QuestionOptionsDropdownComponent,
  [QuestionType.RankSort]: QuestionOptionsDropdownComponent
};
